import { Button, CloseButton, Form, InputGroup } from 'react-bootstrap';
import { useState, useEffect } from 'react';

export const GradeSettingPopup = ({ setVisiblePopup, popupType, teacherGradeGroupList, onSubmit, attendanceUseFlag, onlineAttendanceUseFlag }) => {
  const [popupData, setPopupData] = useState([]);

  useEffect(() => {
    if (popupType === '출석') {
      const onlineData = teacherGradeGroupList.find((group) => group.groupName === '온라인 출석');
      setPopupData([
        {
          groupName: '온라인 출석',
          possiblePoint: onlineData?.possiblePoint || '',
          groupWeight: onlineData?.groupWeight || '',
          isOpen: onlineData?.open || false,
        },
      ]);
    } else if (popupType === '항목 추가') {
      // 기본 상태 설정
      setPopupData([
        {
          groupName: '', // 초기값 빈 문자열로 설정
          possiblePoint: '',
          groupWeight: '',
          isOpen: false,
        },
      ]);
    } else {
      const targetData = teacherGradeGroupList.find((group) => group.groupName === popupType);
      if (targetData) {
        setPopupData([
          {
            groupName: targetData.groupName,
            possiblePoint: targetData.possiblePoint || '',
            groupWeight: targetData.groupWeight || '',
            isOpen: targetData.open || false,
          },
        ]);
      }
    }
  }, [popupType, teacherGradeGroupList]);

  const closePopup = () => {
    setVisiblePopup(false);
  };

  const handleInputChange = (index, field, value) => {
    
    setPopupData((prev) => {
      const updatedData = [...prev];
      updatedData[index] = {
        ...updatedData[index],
        [field]: field === 'isOpen' ? value : parseInt(value) || '',
      };
      return updatedData;
    });
  };

  const handleGroupNameInputChange = (index, field, value) => {
    setPopupData((prev) => {
      const updatedData = [...prev];
      updatedData[index] = {
        ...updatedData[index],
        [field]: value,
      };
      return updatedData;
    });
  };

  const handleSubmit = () => {
    onSubmit(popupData); // 서버로 전송
    closePopup();
  };
  return (
    <>
      <div onClick={closePopup} className='backdrop w-100 h-100 position-fixed top-0 start-0'></div>
      <div className='bg-white position-fixed position-center p-4 rounded-2 popupContainer w-50'>
        <div className='d-flex align-items-center justify-content-between border border-start-0 border-end-0 border-top-0'>
          <h3 className='h2 text-gray1 fw-bold py-2 mb-3'>{popupType}</h3>
          <CloseButton onClick={closePopup} style={{ fontSize: '24px' }} />
        </div>

        {popupData.map((item, index) => (
          <div key={index} className='border border-top-0 border-start-0 border-end-0 py-3'>
            {popupType === '항목 추가' && (
              <>
                <div className='row align-items-center py-3'>
                  <label className='col-3 fw-bold' htmlFor={`possiblePoint-${index}`}>
                    항목
                  </label>
                  <InputGroup className='col-auto p-0 align-items-center' style={{ width: '250px' }}>
                    <Form.Control
                      value={item.groupName}
                      onChange={(e) => handleGroupNameInputChange(index, 'groupName', e.target.value)}
                      placeholder="항목 이름 입력"
                      aria-label="Group Name"
                    />
                  </InputGroup>
                </div>
                <div className='row align-items-center py-3'>
                  <label className='col-3 fw-bold' htmlFor={`possiblePoint-${index}`}>
                    배점
                  </label>
                  <InputGroup className='col-auto p-0 align-items-center' style={{ width: '250px' }}>
                    <Form.Control
                      value={item.possiblePoint}
                      onChange={(e) => handleInputChange(index, 'possiblePoint', e.target.value)}
                      placeholder='0'
                      aria-label='Possible Point'
                    />
                    <InputGroup.Text id='basic-addon2'>점</InputGroup.Text>
                  </InputGroup>
                </div>
              </>
            )}
            <div className='row align-items-center py-3'>
              <label className='col-3 fw-bold' htmlFor={`groupWeight-${index}`}>
              {
                item.groupName === '온라인 출석'
                  ? "온라인 출석 가중치 (%)"
                  : "가중치 (%)"
              }
              </label>
              <InputGroup className='col-auto p-0 align-items-center' style={{ width: '250px' }}>
                <Form.Control
                  value={item.groupWeight}
                  onChange={(e) => handleInputChange(index, 'groupWeight', e.target.value)}
                  placeholder='0'
                  aria-label='Group Weight'
                  disabled={
                    (item.groupName === '온라인 출석' && onlineAttendanceUseFlag === 'N')
                  }
                />
                <InputGroup.Text id='basic-addon2'>%</InputGroup.Text>
              </InputGroup>
            </div>
            {!(item.groupName === '온라인 출석') && !(popupType === '항목 추가') && (
              <div className='row align-items-center py-3'>
                <label className='col-3 fw-bold' htmlFor={`possiblePoint-${index}`}>
                  배점
                </label>
                <InputGroup className='col-auto p-0 align-items-center' style={{ width: '250px' }}>
                  <Form.Control
                    value={item.possiblePoint}
                    onChange={(e) => handleInputChange(index, 'possiblePoint', e.target.value)}
                    placeholder='0'
                    aria-label='Possible Point'
                  />
                  <InputGroup.Text id='basic-addon2'>점</InputGroup.Text>
                </InputGroup>
              </div>
            )}

            <div className='row align-items-center py-3'>
              <label className='col-3 fw-bold' htmlFor='isOpen'>
                항목 점수 비공개
              </label>
              <Form.Check
                className='col-auto p-0 m-0'
                type='checkbox'
                id='isOpen'
                checked={item.isOpen}
                disabled={
                  (item.groupName === '온라인 출석' && onlineAttendanceUseFlag === 'N')
                }
                onChange={(e) => handleInputChange(index, 'isOpen', e.target.checked)}
                style={{ width: '250px' }}
              />
            </div>
          </div>
        ))}

        <div className='d-flex justify-content-center mt-5'>
          <Button className='mx-1' variant='primary' onClick={handleSubmit}>
            등록
          </Button>
          <Button className='mx-1' variant='secondary' onClick={closePopup}>
            취소
          </Button>
        </div>
      </div>
    </>
  );
};